import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { QuienesSomos } from './pages/QuienesSomos';
import { MenuPage } from './pages/MenuPage';
import { Reservas } from './pages/Reservas';
import { Sedes } from './pages/Sedes';
import { Contacto } from './pages/Contacto';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route element={<Layout data-id="element-3" />} data-id="element-2">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/quienes-somos" element={<QuienesSomos data-id="element-7" />} data-id="element-6" />
          <Route path="/menu" element={<MenuPage data-id="element-9" />} data-id="element-8" />
          <Route path="/reservas" element={<Reservas data-id="element-11" />} data-id="element-10" />
          <Route path="/sedes" element={<Sedes data-id="element-13" />} data-id="element-12" />
          <Route path="/contacto" element={<Contacto data-id="element-15" />} data-id="element-14" />
        </Route>
      </Routes>
    </BrowserRouter>;
}